import React, { useState, useEffect } from 'react';
import DOMPurify from "dompurify";

function ImageMCScrambledPreview({ assessmentItem }) {
    const [shuffledResponses, setShuffledResponses] = useState([]);

    useEffect(() => {
        const responses = [
            assessmentItem.correct,
            assessmentItem.distractor1,
            assessmentItem.distractor2,
            assessmentItem.distractor3,
        ];
        setShuffledResponses(responses.sort(() => 0.5 - Math.random()));
    }, [assessmentItem]);

    const renderHtml = (htmlString) => {
        const sanitizedHtml = DOMPurify.sanitize(htmlString);
        return { __html: sanitizedHtml };
    };

    return (
        <div className={'mx-auto'}>
            <div className={'flex flex-col gap-2 bg-columbia_blue-400 p-1 rounded'}>
                {(Object.keys(assessmentItem).includes('imageURL')) &&
                    <img className={`max-h-[200px] rounded my-auto`}
                         src={assessmentItem.imageURL}/>
                }
                <div className={'bg-platinum rounded p-2 border-2 border-columbia_blue'}>
                    <div dangerouslySetInnerHTML={renderHtml(assessmentItem.prompt)} />
                </div>
                <div className={'grid grid-cols-2 gap-2'}>
                    {shuffledResponses.map((item, index) => (
                        (item === assessmentItem.correct) ?
                            <div key={index}
                                 className={'group flex bg-dutch_white-200 hover:bg-columbia_blue-800 hover:text-dutch_white-100 text-sm rounded p-1 border-2 border-opacity-50 border-dutch_white-700 hover:border-dutch_white-100 text-left mx-auto'}>
                                <svg// Position the label just above the bottom of the bar
                                    width={20}
                                    height={20}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="black"
                                    strokeWidth="2"
                                    className={'group-hover:opacity-100 opacity-0 my-auto'}
                                >{/* Added fill to rectangle */}
                                    <path d="M4 12 L8 16 L16 8" stroke="#f6f0e0" strokeWidth="1.5" fill="none"/>
                                    {/* Centered the checkmark */}
                                </svg>
                                <img className={'w-[100px] mr-[20px]'} src={item} alt={`option-${index + 1}`} />
                            </div>
                            :
                            <div key={index}
                                 className={'bg-dutch_white-200 text-sm flex rounded p-1 border-2 border-opacity-50 border-dutch_white-700 mx-auto'}>
                                <img className={'w-[100px] mx-[20px]'} src={item} alt={`option-${index + 1}`}/>
                            </div>
                        // <div key={index} className={'bg-dutch_white-200 rounded p-2 border-2 border-opacity-50 border-dutch_white-700 h-fit w-fit m-auto'}>
                        //     <img className={'w-[100px]'} src={item} alt={`option-${index + 1}`} />
                        // </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ImageMCScrambledPreview;
